/**
 *  初始发行是 100 亿 ycc
    区块奖励是每个区块 15 个 ycc
    所以当前发行数量= 100 亿+15*区块高度
    *注： 高度 725000 之前每个区块的奖励时 30ycc，所以更准确的发行数量为：
    100 亿+30*725000 + 15*（当前高度-725000）
 */
export const yccDifferenceBlockRewardHeight = 725000;

